const translations: any = {
    Search: 'Tìm',
    'Find Your Best Working Place': 'Khám Phá Văn Hoá Công Ty',
    'Enter company name': 'Nhập tên công ty',
    'Discover companies from the inside and find your best working place.': 'Tìm hiểu văn hoá công ty và chọn cho bạn nơi làm việc phù hợp nhất.',
    'No result': 'Không có kết quả',
    'All Categories': 'Tất Cả Ngành Nghề'
}

export default translations
